import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SkeletonLoaderModule } from 'src/app/shared/skeleton-loader/skeleton-loader.module';
import { CompanyPageWorkflowStepWarningModalComponent } from './company-page-workflow-step-warning-modal.component';

@NgModule({
  declarations: [CompanyPageWorkflowStepWarningModalComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    SkeletonLoaderModule
  ],
  exports: [CompanyPageWorkflowStepWarningModalComponent],
  entryComponents: [CompanyPageWorkflowStepWarningModalComponent]
})
export class CompanyPageWorkflowStepWarningModalModule { }
